import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { NgClass } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButtonModule, NgClass, AngularSvgIconModule],
})
export class ButtonComponent {
  @Input() buttonText: string | undefined;
  @Input() theme: string | undefined;
  @Input() iconUrl: string | undefined;
  @Input() id?: string;
}
